export default __webpack_public_path__ + "static/media/red-2.0e1bf24b.png";